var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.3536 4.85355C15.5488 4.65829 15.5488 4.34171 15.3536 4.14645L12.1716 0.964466C11.9763 0.769204 11.6597 0.769204 11.4645 0.964466C11.2692 1.15973 11.2692 1.47631 11.4645 1.67157L14.2929 4.5L11.4645 7.32843C11.2692 7.52369 11.2692 7.84027 11.4645 8.03553C11.6597 8.2308 11.9763 8.2308 12.1716 8.03553L15.3536 4.85355ZM0 5H15V4H0V5Z","fill":"#3872E9"}));
}

LinkArrow.defaultProps = {"className":"link-arrow","width":"16","height":"9","viewBox":"0 0 16 9","fill":"none"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
